import { Avatar } from "@mui/material"
import createAvatar from "minimals-template/components/utils/createAvatar"

export function CompanyAvatar({ client, alt = "", sx }) {
    const name = client.name || client.displayName
    const avatar = createAvatar(name ?? "Company")

    return (
        <Avatar
            variant="rounded"
            src={client.photoURL}
            alt={alt}
            sx={{ width: 40, height: 40, bgcolor: avatar.color, color: "#333", ...sx }}
        >
            {avatar.name}
        </Avatar>
    )
}
